export default "__VITE_ASSET__C0b6xR27__"